import React from 'react';
import SelectField from '../../../../FormControl/input/SelectField';
import { useSelector } from 'react-redux';

const SelectYearLevel = ({ onChange, value, onClear, disabled, error }) => {
  const yearLevels = useSelector((state) => state?.periodicalReport?.yearLevels || []);
  const options = yearLevels.map((item) => ({ value: item._id, label: item.name }));

  return (
    <SelectField
      placeholder='Choose an year level'
      options={options}
      error={error}
      helperText={error}
      onChange={onChange}
      value={value}
      onClear={onClear}
      disabled={disabled}
    />
  );
};

export default SelectYearLevel;
